import CryptoJS from "crypto-js";

const HIDDEN_JWT_KEY = "jwt_pixels_hidden";
const MAIN_JWT_KEY = "jwt_pixels";

export function getEncryptedToken(token: string): string {
  return CryptoJS.AES.encrypt(
    token,
    import.meta.env.VITE_CRYPTO_SECRET_KEY ?? ""
  ).toString();
}

export function getDecryptedToken(encryptedJwt: string): string {
  const bytes = CryptoJS.AES.decrypt(
    encryptedJwt,
    import.meta.env.VITE_CRYPTO_SECRET_KEY ?? ""
  );
  return bytes.toString(CryptoJS.enc.Utf8);
}

export function encryptAndStoreToken(token: string): void {
  const encryptedToken = getEncryptedToken(token);
  localStorage.setItem(MAIN_JWT_KEY, encryptedToken);
}

export function loadDecryptedToken(): string | undefined {
  const encryptedJwt = localStorage.getItem(MAIN_JWT_KEY);
  if (encryptedJwt) {
    try {
      return getDecryptedToken(encryptedJwt);
    } catch (error) {
      console.error("Failed to decrypt JWT:", error);
      return undefined;
    }
  }
  return undefined;
}

export enum TokenType {
  STYTCH = "STYTCH",
  JOIN = "JOIN",
  UNKNOWN = "UNKNOWN",
}

export type DecryptedJwtResult = [string | undefined, TokenType];

export const getDecryptedJwtAndType = (): DecryptedJwtResult => {
  // check first for anonymous user ID and join token
  const anonUserId = localStorage.getItem("anon_user_id");
  const joinToken = localStorage.getItem("join_token");
  if (anonUserId && joinToken) {
    console.log("anonUserId: ", anonUserId);
    return [joinToken, TokenType.JOIN];
  }

  // ... then check for encrypted JWT
  const decryptedJwt = loadDecryptedToken();
  if (decryptedJwt) {
    return [decryptedJwt, TokenType.STYTCH];
  }
  return [undefined, TokenType.UNKNOWN];
};

export const getDecryptedJwt = (): string | undefined => {
  const [jwt] = getDecryptedJwtAndType();
  return jwt;
};

export const hideEncryptedToken = (): void => {
  // Move jwt_pixels → jwt_pixels_hidden, overwriting if needed
  const encryptedJwt = localStorage.getItem(MAIN_JWT_KEY);
  if (encryptedJwt) {
    localStorage.setItem(HIDDEN_JWT_KEY, encryptedJwt);
    localStorage.removeItem(MAIN_JWT_KEY);
  }
};

export const unhideEncryptedToken = (): boolean => {
  // Move jwt_pixels_hidden → jwt_pixels, overwriting if needed
  const hiddenEncryptedJwt = localStorage.getItem(HIDDEN_JWT_KEY);
  if (hiddenEncryptedJwt) {
    localStorage.setItem(MAIN_JWT_KEY, hiddenEncryptedJwt);
    localStorage.removeItem(HIDDEN_JWT_KEY);
    return true;
  }
  return false;
};
